<template>
  <div class="dict-card__mapping helfen-mapping" v-if="rows.length">
    <div class="dict-card__mapping-grid dict-card__mapping--desktop">
      <div class="dict-card__mapping-header dict-card__mapping-header--gendered dict-card__mapping-header--desktop">
        {{ $t('dict.for_label') }}
      </div>
      <div class="dict-card__mapping-header-bridge dict-card__mapping-header--desktop" aria-hidden="true"></div>
      <div class="dict-card__mapping-header dict-card__mapping-header--alt dict-card__mapping-header--desktop">
        {{ $t('dict.neutral_label') }}
      </div>
      <div
        v-for="(row, rowIndex) in rows"
        :key="row.key"
        class="dict-mapping-row"
      >
        <div
          v-if="rowIndex === 0"
          class="dict-card__mapping-header dict-card__mapping-header--gendered dict-card__mapping-header--mobile"
        >
          {{ $t('dict.for_label') }}
        </div>
        <div class="dict-mapping-row__gendered">
          <span class="dict-mapping-row__scope" aria-hidden="true">
            <i :class="row.icon"></i>
          </span>
          <span class="dict-word-list">
            <template v-for="(word, idx) in row.genderedWords">
              <span
                :key="row.key + '-word-' + idx"
                class="dict-word-plain"
              >{{ word.text }}</span>
              <span
                v-if="idx < row.genderedWords.length - 1"
                :key="row.key + '-sep-' + idx"
                class="dict-word-sep"
              > · </span>
            </template>
          </span>
        </div>
        <div class="dict-mapping-row__arrow" aria-hidden="true">
          <i class="fa fa-arrow-right dict-mapping-row__arrow-icon dict-mapping-row__arrow-icon--right"></i>
          <i class="fa fa-arrow-down dict-mapping-row__arrow-icon dict-mapping-row__arrow-icon--down"></i>
        </div>
        <div class="dict-card__mapping-header dict-card__mapping-header--alt dict-card__mapping-header--mobile">
          {{ $t('dict.neutral_label') }}
        </div>
        <div class="dict-mapping-row__neutral dict-mapping-row__neutral--input">
          <label
            v-if="showFieldLabel(row)"
            class="helfen-mapping__field-label"
            :for="inputId(row)"
          >{{ fieldLabel(row) }}</label>
          <input
            :id="inputId(row)"
            type="text"
            class="helfen-mapping__input"
            :value="inputValue(row)"
            :placeholder="inputPlaceholder(row)"
            autocomplete="off"
            @input="onInput(row, $event.target.value)"
            @keydown.enter.prevent="$emit('submit')"
          >
        </div>
      </div>
    </div>

    <div class="dict-mapping-compact dict-card__mapping--mobile">
      <div
        v-for="row in rows"
        :key="'compact-' + row.key"
        class="dict-mapping-compact__row"
      >
        <span class="dict-mapping-compact__icon" aria-hidden="true">
          <i :class="row.icon"></i>
        </span>
        <div class="dict-mapping-compact__content">
          <span class="sr-only" v-if="scopeLabel(row)">{{ scopeLabel(row) }}</span>
          <label class="sr-only" :for="inputId(row) + '-mobile'">{{ inputPlaceholder(row) }}</label>
          <span class="dict-word-list dict-mapping-compact__words">
            <template v-for="(word, idx) in row.genderedWords">
              <span
                :key="row.key + '-compact-word-' + idx"
                class="dict-word-plain"
              >{{ word.text }}</span>
              <span
                v-if="idx < row.genderedWords.length - 1"
                :key="row.key + '-compact-sep-' + idx"
                class="dict-word-sep"
              > · </span>
            </template>
          </span>
          <div class="dict-mapping-compact__input-row">
            <input
              :id="inputId(row) + '-mobile'"
              type="text"
              class="helfen-mapping__input"
              :value="inputValue(row)"
              :placeholder="inputPlaceholder(row)"
              autocomplete="off"
              @input="onInput(row, $event.target.value)"
              @keydown.enter.prevent="$emit('submit')"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { genderedSourceRows } from '../utils/genderedFormLabel'

export default {
  name: 'HelfenMappingRows',
  props: {
    entry: { type: Object, required: true },
    singularNeutral: { type: String, default: '' },
    pluralNeutral: { type: String, default: '' },
    alternativeNeutral: { type: String, default: '' },
    singularPlaceholder: { type: String, default: '' },
    pluralPlaceholder: { type: String, default: '' },
    termPlaceholder: { type: String, default: '' }
  },
  computed: {
    rows () {
      return genderedSourceRows(this.entry)
    }
  },
  methods: {
    scopeLabel (row) {
      if (row.inputType === 'singular') return this.$t('dict.scope_singular')
      if (row.inputType === 'plural') return this.$t('dict.scope_plural')
      return ''
    },
    inputId (row) {
      return 'helfen-input-' + row.inputType
    },
    inputValue (row) {
      if (row.inputType === 'term') return this.alternativeNeutral
      if (row.inputType === 'singular') return this.singularNeutral
      if (row.inputType === 'plural') return this.pluralNeutral
      return ''
    },
    inputPlaceholder (row) {
      if (row.inputType === 'term') return this.termPlaceholder
      if (row.inputType === 'singular') return this.singularPlaceholder
      if (row.inputType === 'plural') return this.pluralPlaceholder
      return ''
    },
    showFieldLabel (row) {
      return this.rows.length > 1 && row.inputType !== 'term'
    },
    fieldLabel (row) {
      if (row.inputType === 'singular') return this.$t('helfen.input_singular')
      if (row.inputType === 'plural') return this.$t('helfen.input_plural')
      return ''
    },
    onInput (row, value) {
      if (row.inputType === 'term') {
        this.$emit('update:alternativeNeutral', value)
      } else if (row.inputType === 'singular') {
        this.$emit('update:singularNeutral', value)
      } else if (row.inputType === 'plural') {
        this.$emit('update:pluralNeutral', value)
      }
    }
  }
}
</script>
